import { configureStore } from '@reduxjs/toolkit';
import NotesReducer from './apps/notes/NotesSlice';
import CustomizerReducer from './customizer/CustomizerSlice';
import ChatsReducer from './apps/chat/ChatSlice';
import ContactsReducer from './apps/contacts/ContactSlice';
import EmailReducer from './apps/email/EmailSlice';
import TicketReducer from './apps/ticket/TicketSlice';
import clientMasterSlice from './apps/contacts/clientMasterSlice';
import messageScheduleSlice from './apps/messageSchedule/messageScheduleSlice';
import groupMasterSlice from './apps/groups/groupMasterSlice';
import groupParticipateSlice from './apps/groups/groupParticipateSlice';
import msgLogSlice from './apps/messageLog/msgLogSlice';
import receiveMsgHistorySlice from './apps/receiveMsgHistory/receiveMsgHistorySlice';

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    notesReducer: NotesReducer,
    chatReducer: ChatsReducer,
    contactsReducer: ContactsReducer,
    emailReducer: EmailReducer,
    ticketReducer: TicketReducer,
    clientreducer: clientMasterSlice,
    messageScheduleReducer: messageScheduleSlice,
    groupMasterReducer: groupMasterSlice,
    groupParticipateSliceReducer: groupParticipateSlice,
    msgLogReducer: msgLogSlice,
    receiveMsgHistoryReducer: receiveMsgHistorySlice,
  },
});

export default store;
